export async function generateBlurDataURL(url: string) {
    try {
        const newUrl = url.replace('https://a.storyblok.com', 'https://a2.storyblok.com');
        const response = await fetch(newUrl);
        const arrayBuffer = await response.arrayBuffer();
        const prefix = 'data:image/webp;base64,';
        const base64 = btoa(new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ''));
        return prefix + base64;
    } catch (error) {
        return '';
    }
}
